import AIWorkoutGenerator from './AIWorkoutGenerator';

export default AIWorkoutGenerator;
